import { trackMetaEvent, getMetaCookies } from "@/lib/meta";

let scriptPromise = null;

export function loadRazorpay() {
  if (window.Razorpay) return Promise.resolve(true);
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve) => {
      const s = document.createElement("script");
      s.src = "https://checkout.razorpay.com/v1/checkout.js";
      s.onload = () => resolve(true);
      s.onerror = () => { scriptPromise = null; resolve(false); };
      document.body.appendChild(s);
    });
  }
  return scriptPromise;
}

// tracking (optional): { content_name, content_type, product_type, programme_id } — fires Meta InitiateCheckout
// right before the Razorpay modal opens. Purchase itself is NEVER fired here — only after backend verification.
export async function openCheckout({ keyId, orderId, amount, currency = "INR", description, prefill = {}, tracking }) {
  if (tracking) {
    trackMetaEvent("InitiateCheckout", {
      value: amount ? amount / 100 : undefined,
      currency,
      content_name: tracking.content_name,
      content_type: tracking.content_type,
      product_type: tracking.product_type,
      programme_id: tracking.programme_id,
    }, `checkout-${orderId}`);
  }
  const ok = await loadRazorpay();
  if (!ok) throw new Error("Could not load the payment gateway. Please try again.");
  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: keyId,
      order_id: orderId,
      amount,
      currency,
      name: "Planet Trotter Foundation",
      description: description || "",
      prefill,
      theme: { color: "#0C3244" },
      handler: (response) => resolve({ ...response, ...getMetaCookies() }),
      modal: { ondismiss: () => reject(new Error("Payment window closed before completing.")) },
    });
    rzp.open();
  });
}
